import React from 'react';

export interface LanguageListItemProps {
  id?: number;
  code?: string;
  name: string;
  flagIcon: string;
  selected: boolean;
  handleClick?: (e: any) => void;
}

const LanguageListItem: React.FC<LanguageListItemProps> = ({code, name, flagIcon, selected, handleClick }) => {
  const _handleClick = () => {
    handleClick?.(code)
  }

  return (
    <div onClick={_handleClick} className={`flex flex-1 gap-3.5 p-3.5 mb-[10px] ${selected ? 'bg-[#fff7f5] !border-[#ff6741]' : 'bg-white'} rounded-lg border border-solid border-zinc-300`}>
      <img 
        src={flagIcon} 
        alt={`${name} flag`} 
        className="shrink-0 rounded aspect-[1.35] w-[50px] border border-[1px] border-black/5 bg-white" 
      />
      <div className="my-auto text-[13px] font-medium">{name}</div>
    </div>
  );
};

export default LanguageListItem;